/* eslint-disable global-require */
const axios = require('axios')

// Cria a instância do axios com a URL base
const api = axios.create({
  baseURL: 'https://mc-analytics.manyconvert.com',
})

async function getAudiences(storeUuid) {
  const res = await api.get(`/api/stores/${storeUuid}/audiences`)
  return res.data.data
}

async function getAudience(storeUuid, audienceId, limit = 50000) {
  // Garantir que o limite não exceda 50000
  const validLimit = Math.min(limit, 50000)
  const res = await api.get(`/api/stores/${storeUuid}/audiences/${audienceId}/leads`, {
    params: { limit: validLimit },
  })
  return res.data.data
}
async function previewAudience(storeUuid, filters) {
  const res = await api.post(`/api/stores/${storeUuid}/audiences/preview-filters`, filters)
  return res.data.data
}

async function createAudience(storeUuid, audienceData) {
  const res = await api.post(`/api/stores/${storeUuid}/audiences`, audienceData)
  return res.data.data
}

async function chatAiForSearchAudience(query, storeUuid, limit = 5) {
  const res = await api.post(`/api/stores/${storeUuid}/ai/translate-and-preview`, {
    query,
    limit,
  })
  return res.data
}

async function deleteAudience(storeUuid, audienceId) {
  const res = await api.delete(`/api/stores/${storeUuid}/audiences/${audienceId}`)
  return res.data
}

async function getRecomendation() {
  return {
    ativo: 1,
    'tipo-mensagem': 'Carrossel',
    mensagem: 'Template selecionado',
    'imagem-produto': 'Imagem do produto',
    'quantas-vezes-semana': 100,
    'ia-training': 0,
  }
}

module.exports = {
  getRecomendation,
  getAudiences,
  getAudience,
  previewAudience,
  createAudience,
  chatAiForSearchAudience,
  deleteAudience,
}
